import { renderInputFieldWithoutLabel } from '../../../../common/inputField';

const EmbryologyET = ({ embryoTransferDetails, handleInputChange }) => {
  return (
    <div className="card">
      <div className="body" style={{ display: 'flex', gap: '10px' }}>
        <table
          cellPadding={'20px'}
          style={{ flexGrow: 1, padding: '0px 10px' }}
        >
          <tbody>
            <tr>
              <td>ET CATHETAR 1</td>
              <td>
                {renderInputFieldWithoutLabel(
                  'ETCathetar1',
                  embryoTransferDetails.ETCathetar1,
                  handleInputChange,
                )}
              </td>
            </tr>
            <tr>
              <td>ET CATHETAR 2</td>
              <td>
                {renderInputFieldWithoutLabel(
                  'ETCathetar2',
                  embryoTransferDetails.ETCathetar2,
                  handleInputChange,
                )}
              </td>
            </tr>
            <tr>
              <td>OBTURATOR</td>
              <td>
                {renderInputFieldWithoutLabel(
                  'obturator',
                  embryoTransferDetails.obturator,
                  handleInputChange,
                )}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default EmbryologyET;
